import { useState } from "react";
import { faqItems } from '@/mocks/homeData';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="relative overflow-hidden bg-background-50 py-12 md:py-16">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-accent-200/50 blur-3xl"></div>
      <div className="relative mx-auto max-w-5xl px-4 md:px-6">
        {/* heading */}
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-chat-check-line"></i>信任与说明
          </p>
          <h2 className="mt-3 font-display text-2xl font-bold text-foreground-950 md:text-[30px]">吃瓜前，先搞清楚这几点</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于信源、辟谣与内容边界的高频疑问，我们都摊开来讲，让你在前排围观时心里更有底。
          </p>
        </div>

        {/* FAQ accordion */}
        <div className="mt-8 divide-y divide-secondary-200 rounded-2xl border border-background-200 bg-background-100/70">
          {faqItems.map((item, i) => {
            const open = openIdx === i;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  aria-expanded={open}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <span className="flex items-start gap-3">
                    <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${open ? 'bg-primary-500 text-background-50' : 'bg-secondary-200 text-secondary-900'}`}>
                      Q{i + 1}
                    </span>
                    <span className={`text-sm font-semibold md:text-base ${open ? 'text-primary-700' : 'text-foreground-900'}`}>{item.q}</span>
                  </span>
                  <i className={`ri-arrow-down-s-line text-xl text-secondary-400 transition-transform ${open ? 'rotate-180 text-primary-500' : ''}`}></i>
                </button>
                {open && (
                  <div className="px-5 pb-5 md:px-6">
                    <div className="ml-9 border-l-2 border-primary-200 pl-4">
                      <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* contact strip */}
        <div className="mt-6 flex flex-col items-start justify-between gap-3 rounded-2xl border border-background-200 bg-background-100 px-5 py-4 sm:flex-row sm:items-center md:px-6">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50"><i className="ri-mail-send-line"></i></span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">还有疑问，或想提供一线线索？</p>
              <p className="text-xs text-foreground-600">我们会先做初步核验再决定是否收录进吃瓜现场速递。</p>
            </div>
          </div>
          <a href="#faq" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors">
            <i className="ri-customer-service-2-line"></i>联系 cg51
          </a>
        </div>
      </div>
    </section>
  );
}